export default "__VITE_ASSET__Dpije_D0__"